export const firebaseConfig = {
  apiKey: 'AIzaSyC7kHFCdHoGymImOYzoRbOuGgdJk5WdhLE',
  authDomain: 'befree-social-c05b5.firebaseapp.com',
  databaseURL: 'https://befree-social-c05b5.firebaseio.com',
  projectId: 'befree-social-c05b5',
  storageBucket: 'befree-social-c05b5.firebasestorage.app',
  messagingSenderId: '129953491100',
  appId: '1:129953491100:web:0dbb2cb81378e80365a559',
  measurementId: 'G-CLYLHFVZVR',
};

export const firebaseVapidKey =
  'BE-uKbbt1WkztuNoeAPnaAcsUNlGSyotRHopcvKm9J6gWy5ssE_tVEuIR0kmO8sH6LwGz_YsK0i2JOlP586639c';

/** Не в корне `/*.js` — иначе ngsw префетчит и отдаёт старый скрипт, ломая FCM и обновления SW. */
export const firebaseMessagingSwUrl =
  '/firebase-cloud-messaging-push-scope/firebase-messaging-sw.js';

export const firebaseMessagingSwScope = '/firebase-cloud-messaging-push-scope/';
